import styled from "styled-components";
import { MainInner, responsiveFontSize, responsiveFontSizeM, responsiveFontSizeL } from "@/styles/global";
import { FondCardPadding } from "@/styles/typography";
import {h2Css} from "@/styles/typography";

const RegionDestributionWrapper = styled(MainInner)`
    ${FondCardPadding}
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 20px;
`;

const RegionDestributionMapWrapper = styled.div`
    max-width: 700px;
    width: 100%;
    margin: 0 auto;
`;

const RegionDistributionTableWrapper = styled.div`
    flex: 1;
`;

const RegionDistrubtionTableHeader = styled.div`
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    justify-content: space-between;
    border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
    padding-bottom: 5px;
    align-items: center;
`;

const RegionDistributionTable = styled.table`
    ${responsiveFontSize}
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    font-family: "Open Sans";
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    color: ${({ theme }) => theme.colors.breadText};
    
    th, td {
        border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
        padding: 10px;
    }

    /* Text align right on everything except the first column */
    th, td {
        text-align: right;

        &:first-child {
            text-align: left;
        }
    }
    
    thead th {
        font-family: "Open Sans";
        ${responsiveFontSizeM}
        font-style: normal;
        font-weight: 600;
        line-height: 150%;
    }
`;

const RegionDistributionTableHeaderHeading = styled.h2`
    ${h2Css}
    ${responsiveFontSizeL}
    color: ${({ theme }) => theme.colors.title};
`;

const RegionDistributionTableHeaderDate = styled.div`
    color: ${({ theme }) => theme.colors.breadText};
    font-family: "Open Sans";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
`;

const RegionDistrubtionTableHeaderCell = styled.div`
    font-weight: bold;
`;

const S = {
    RegionDestributionWrapper,
    RegionDestributionMapWrapper,
    RegionDistributionTableWrapper,
    RegionDistrubtionTableHeader,
    RegionDistrubtionTableHeaderCell,
    RegionDistributionTableHeaderHeading,
    RegionDistributionTableHeaderDate,
    RegionDistributionTable
};

export default S;
